import { render, staticRenderFns } from "./exitEmail.vue?vue&type=template&id=b4b92938&scoped=true"
import script from "./exitEmail.vue?vue&type=script&lang=js"
export * from "./exitEmail.vue?vue&type=script&lang=js"
import style0 from "./exitEmail.vue?vue&type=style&index=0&id=b4b92938&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b92938",
  null
  
)

export default component.exports